export const PaymentErrorView = () => {
    return (
        <div>
            <h1>Payment Error</h1>
        </div>
    );
};
